import { DATE_FORMAT, ListItem, Pill, SERVER_DATE_FORMAT, StringUtils, TIME_FORMAT, TPillTone } from '@localina/core';
import { RemoveMinusIcon } from '@localina/icons';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TRestaurantClosingDayTransformed } from '../../api/queries/restaurantShifts';

interface IProps {
    closingDay: TRestaurantClosingDayTransformed;
    onClick: (closingDay: TRestaurantClosingDayTransformed) => void;
}

export const ClosingDayListItem: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const title = props.closingDay.name;
    const dateFrom = DateTime.fromFormat(props.closingDay.from, SERVER_DATE_FORMAT).toFormat(DATE_FORMAT);
    const dateTo = DateTime.fromFormat(props.closingDay.to, SERVER_DATE_FORMAT).toFormat(DATE_FORMAT);
    const timeFrom = DateTime.fromFormat(props.closingDay.fromTime ?? '', TIME_FORMAT);
    const timeTo = DateTime.fromFormat(props.closingDay.toTime ?? '', TIME_FORMAT);

    let subtitle = '';
    if (props.closingDay.isRecurrent) {
        subtitle = StringUtils.combineStrings(
            [
                StringUtils.combineStrings([dateFrom, dateTo], ' – '),
                StringUtils.combineStrings(
                    [
                        timeFrom.isValid && timeFrom.toFormat(TIME_FORMAT),
                        timeTo.isValid && timeTo.toFormat(TIME_FORMAT),
                    ],
                    ' – ',
                ),
            ],
            ' · ',
        );
    } else {
        subtitle = StringUtils.combineStrings(
            [
                StringUtils.combineStrings([dateFrom, timeFrom.isValid && timeFrom.toFormat(TIME_FORMAT)]),
                StringUtils.combineStrings([dateTo, timeTo.isValid && timeTo.toFormat(TIME_FORMAT)]),
            ],
            ' – ',
        );
    }

    const today = DateTime.now().toFormat(SERVER_DATE_FORMAT);
    let status: { label: string; tone: TPillTone; extraClassName?: string };
    if (props.closingDay.to < today) {
        status = { label: t('availability.expired'), tone: 'neutral', extraClassName: 'is-off' };
    } else if (props.closingDay.from > today) {
        status = { label: t('availability.upcoming'), tone: 'neutral' };
    } else {
        status = { label: t('availability.ongoing'), tone: 'teal' };
    }

    const handleClick = () => {
        props.onClick(props.closingDay);
    };

    return (
        <ListItem
            classNames="shift-listitem closingday-listitem"
            leftIcon={
                <span className="shift-listitem__icon">
                    <RemoveMinusIcon />
                </span>
            }
            title={
                <div className="shift-listitem__row">
                    <div className="shift-listitem__main">
                        <span className="shift-listitem__name">{title}</span>
                        <span className="shift-listitem__when" title={subtitle}>
                            {subtitle}
                        </span>
                    </div>
                    <Pill
                        tone={status.tone}
                        label={status.label}
                        extraClassName={`shift-listitem__status${
                            status.extraClassName ? ` ${status.extraClassName}` : ''
                        }`}
                    />
                </div>
            }
            onClick={handleClick}
        />
    );
};
